import React from 'react';
import { Box, Typography, Card, CardContent, Grid } from '@mui/material';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import SpaOutlinedIcon from '@mui/icons-material/SpaOutlined';
import SentimentVerySatisfiedOutlinedIcon from '@mui/icons-material/SentimentVerySatisfiedOutlined';

const assessmentCards = [
  {
    icon: <EmojiEventsOutlinedIcon sx={{ fontSize: 40, color: 'primary.main', mb: 1 }} />, // Strengths Assessment
    title: 'Strengths Assessment',
    desc: 'Identify your core character strengths and learn how to use them for confidence, resilience, and authentic living.'
  },
  {
    icon: <SpaOutlinedIcon sx={{ fontSize: 40, color: 'custom.red', mb: 1 }} />, // Happiness Activities Diagnostic
    title: 'Happiness Activities Diagnostic',
    desc: 'Discover which daily activities and habits truly increase your happiness and emotional balance.'
  },
  {
    icon: <SentimentVerySatisfiedOutlinedIcon sx={{ fontSize: 40, color: 'custom.blue', mb: 1 }} />, // Happiness & Life Satisfaction Scale
    title: 'Happiness & Life Satisfaction Scale',
    desc: 'Get a clear picture of your current wellbeing and track positive change over time.'
  },
];

const Assessments = () => (
  <Box sx={{ bgcolor: 'custom.yellow', py: { xs: 4, md: 6 }, px: { xs: 1, md: 0 } }}>
    <Box sx={{ maxWidth: 1100, mx: 'auto' }}>
      <Typography variant="h2" sx={{ color: 'text.secondary', mb: 2, textAlign: 'center', fontFamily: 'Just Another Hand' }}>
        The 3 Science-Based Assessments
      </Typography>
            <Typography sx={{ color: 'text.secondary', textAlign: 'center', fontSize: 15, mb: 2 }}>
              As part of the CYJ Self-Discovery Program, you’ll receive three carefully selected assessments grounded in Positive Psychology research. These tools help you understand yourself beyond emotions of the moment — giving you clear insight into your strengths, wellbeing, and life satisfaction.
            </Typography>
      <Grid container spacing={3} justifyContent="center">
        {assessmentCards.map((item, idx) => (
          <Grid item xs={12} sm={6} md={4} key={item.title}>
            <Card elevation={3} sx={{ borderRadius: 3, p: 2, height: '100%', bgcolor: 'background.paper', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>{item.icon}</Box>
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>{item.title}</Typography>
                <Typography sx={{ color: 'text.secondary', fontSize: 15 }}>{item.desc}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Typography sx={{ color: 'text.secondary', textAlign: 'center', fontSize: 15, mt: 4 }}>
        Together, these science-based assessments deepen your self-awareness, support your personal growth, and guide your journey with clarity and intention — all inspired by the foundations of Positive Psychology.
      </Typography>
    </Box>
  </Box>
);

export default Assessments;
